import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import queryString from 'query-string';

import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import {
  COUPON_TYPES,
  CUSTOMER_DETAIL_COUPON_TYPE,
  DISPLAY_COUPON_TYPES,
} from 'config/CustomEnums';

function CustomerRewardListFilter({ backAction = () => {} }) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search.slice(1));
  const searchType = parsedSearch['type'] || '';
  const searchCouponType = parsedSearch['coupon_type'] || '';

  const [type, setType] = useState(searchType);
  const [couponType, setCouponType] = useState(searchCouponType);

  const content = [
    {
      title: 'Type',
      data: [
        { pk: CUSTOMER_DETAIL_COUPON_TYPE.available, name: 'Available' },
        { pk: CUSTOMER_DETAIL_COUPON_TYPE.unavailable, name: 'Unavailable' },
        {
          pk: CUSTOMER_DETAIL_COUPON_TYPE.used_or_expired,
          name: 'Used or expired',
        },
      ],
      value: type,
      setValue: setType,
      component: FilterTypeEnum.singleChoice,
    },
    {
      title: 'Coupon type',
      data: [
        {
          name: DISPLAY_COUPON_TYPES?.[COUPON_TYPES.NORMAL],
          pk: COUPON_TYPES.NORMAL,
        },
        {
          name: DISPLAY_COUPON_TYPES?.[COUPON_TYPES.TICKET],
          pk: COUPON_TYPES.TICKET,
        },
      ],
      value: couponType,
      setValue: setCouponType,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default CustomerRewardListFilter;
